import React from "react";
import { Typography, Button, Dialog, DialogContent, DialogActions } from "@mui/material";

import theme from "../theme";

interface DialogBoxBiometricProps {
  open: boolean;
  /** Display label of the biometric method, e.g. "Face ID" or "Biometrics". */
  methodName: string;
  loading?: boolean;
  onEnable: () => void;
  onDecline: () => void;
}

const createStyles = () => ({
  header: {
    color: theme.palette.primary.main,
    marginBottom: "10px",
  },
  dialogBox: {
    width: "380px",
  },
});

/**
 * Prompt shown inside the mobile wrapper after the first successful standard
 * MFA, offering to enable biometric (Face ID / fingerprint) sign-in for
 * subsequent logins.
 */
const DialogBoxBiometric: React.FC<DialogBoxBiometricProps> = (props) => {
  const classes = createStyles();
  const trailingText = props.methodName.toLowerCase().includes("fingerprint") ? " Unlock" : "";

  return (
    <Dialog
      open={props.open}
      onClose={props.onDecline}
      maxWidth={"md"}
      aria-labelledby="biometric-dialog-title"
      sx={{ paper: classes.dialogBox }}
    >
      <DialogContent>
        <Typography variant="h4" sx={classes.header}>
          Enable {props.methodName} {trailingText}
        </Typography>
        <Typography>Enable {props.methodName} {trailingText} to sign in faster next time?</Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={props.onDecline} variant="outlined" color="primary" disabled={props.loading}>
          Not now
        </Button>
        <Button onClick={props.onEnable} variant="contained" color="primary" disabled={props.loading}>
          {props.loading ? "Enabling..." : `Enable`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogBoxBiometric;
